import React, { ReactNode } from 'react';

import { FeaturePlansPurchaseStore } from './plans-purchase.store';

const PlansPurchaseContext = React.createContext<FeaturePlansPurchaseStore | null>(null);

export const PlansPurchaseProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState<FeaturePlansPurchaseStore>(() => new FeaturePlansPurchaseStore());

   return <PlansPurchaseContext.Provider value={store}>{children}</PlansPurchaseContext.Provider>;
};

export const usePlansPurchase = () => {
   const ctx = React.useContext(PlansPurchaseContext);

   if (!ctx) {
      throw new Error('usePlansPurchase must be used inside PlansPurchaseProvider');
   }

   return ctx;
};
